<template>
	<div class="boundmobile">
		<div v-if="inputPhone">
			<div class="line">
				<div class="title" @click="binshowPicker()">
					{{params.area_code}}
					<van-icon name="arrow-down" />
				</div>
				<van-field
				v-model="params.mobile"
				clearable
				maxlength='11'
				type='tel'
				placeholder="输入手机号"
				@input="putMobile"
				/>
			</div>
			<div class="line">
				<div class="title">
					验证码
				</div>
				<van-field
				v-model="code"
				center
				maxlength='6'
				type="number"
				placeholder="输入验证码"
				@input="putCode"
				>
				<template #button>
					<van-button size="small" class="codebtn" @click="getCode()" :disabled="btnDisabled">获取验证码<span v-if="btnDisabled">({{second}}s)</span>
					</van-button>
				</template>
			</van-field>
		</div>
		<van-popup v-model="show" position="bottom">
			<van-picker
			title=""
			show-toolbar
			:columns="columns"
			@confirm="onConfirm"
			@cancel="onCancel"
			@change="onChange"
			/>
		</van-popup>
		<div class="text-c">
			<van-button size="large" @click="nextPage" color="#FFBB00">下一步</van-button>
		</div>
	</div>
	<div v-else>
		<div class="approve-box text-c">
			<img class="approve" :src="img.approve">
			<div class="f-16 f-w">手机号绑定成功</div>
		</div>
    <!-- <div class="f-12 c-gray mt-25 text-c">恭喜您获得以下好礼！</div>
    <div class="mt-25">
      <div class="gift_box">
        <div class="f-12 gift_title">XXX积分 1000</div>
        <div class="getBtn">领取</div>
      </div>
      <div class="gift_box">
        <div class="f-12 gift_title">雷克萨斯镂空机械腕表-男士 1枚</div>
        <div class="getBtn">领取</div>
      </div>
      <div class="gift_box">
        <div class="f-12 gift_title">勋章：XXX1</div>
        <div class="getBtn">领取</div>
      </div>
  </div> -->
  <!-- <div class="iknowBtn" @click="goback()">我知道了</div> -->
</div>

</div>
</template>
<script>
	import member from '../../../api/member/memberinfo';
	import { mapState } from 'vuex';
	import { Grid, GridItem,Field,Button,Icon,Picker,Popup} from 'vant';
	export default {
		data () {
			return {
				inputPhone:true,
				show:false,
				params:{
					mobile:'',
					source:'',
					area_code:'+86'
				},
				columns: ['+86', '+81', '+65'],
				second:60,
				btnDisabled:false,
				code:'',
				img:{
					approve: require('../../../assets/img/member/mobileaudit.png')
				}
			}
		},
		computed: {
			...mapState({
				user: state => state.param.user,
				source: state => state.param.source
			})
		},
		created () {
			if(this.$route.query.token){
				this.token = this.$route.query.token
				this.$store.dispatch('param/setToken', this.$route.query.token)
				this.user_id = this.$route.query.userid
				this.source = this.$route.query.source
			}
			this.$store.commit('param/show', false)
			this.$appService.isShowReturn({state: false})
			this.$appService.isTabbar({state: true})
			this.weburl=process.env.VUE_APP_URL
			this.$appService.getToken(v => {
				if(v.token) {
					this.$store.dispatch('param/setToken', v.token)
				} else {
					this.$appService.needLogin()
				}
			})
			var apppar={
				title:this.$route.meta.title
			}
			this.$appService.changeTitle(apppar)
		},
		methods: {
			binshowPicker(){
				this.show=true
			},
			onConfirm(value, index) {
				console.log(`当前值：${value}, 当前索引：${index}`);
				this.show=false
				this.params.area_code=value
			},
			onChange(picker, value, index) {
				console.log(`当前值：${value}, 当前索引：${index}`)
			},
			onCancel() {
				Toast('取消');
				this.show=false
			},
			putMobile(value){
				this.params.mobile=value
			},
			putCode(value){
				this.code=value
			},
			getCode(){
				let mobile=this.params.mobile
				this.params.source=String.valueOf(this.source)
				if(!(/^1[3456789]\d{9}$/.test(mobile))){
					this.$toast('请填写正确的手机号');
				}else{
					this.btnDisabled=true
					let second = 60;
					member.getCode(this.params).then(res => {
						if(res.data.state == 1) {
							let code=res.data.data
						}
					})
					const timer = setInterval(() => {
						second--;
						if (second) {
							this.second=second
						} else {
							clearInterval(timer);
							this.second=60
							this.btnDisabled=false
						}
					}, 1000);
				}
			},
			nextPage(){
				let mobile=this.params.mobile
				let code=this.code
				var param={
					mobile:mobile,
					code:code,
					source:this.source
				}
				if(!(/^1[3456789]\d{9}$/.test(mobile))){
					this.$toast('请填写正确的手机号');
				}else{
					member.boundMobile(param).then(res => {
						if(res.data.state == 1) {
							this.inputPhone=false
							// var params={
							// 	url:this.weburl+'/lexus/my/mobileaudit?source='+this.source,
							// 	isReturn: false 
							// }
							// this.$appService.openWebView(params)
						}
					})
				}
			}
		},
		components: {
			[Grid.name]: Grid,
			[GridItem.name]: GridItem,
			[Field.name]:Field,
			[Button.name]:Button,
			[Icon.name]:Icon,
			[Picker.name]:Picker,
			[Popup.name]:Popup
		}
	}
</script>
<style lang="scss">
	.boundmobile{
		margin-top: 15px;
		.line{
			padding: 10px 0;
			font-size:14px;
			display: flex;
			border-bottom: 1px solid #EEEEEE;
			.title{
				width: 90px;
				margin-left: 15px;
				align-items: center;
				display: flex;
			}
			.codebtn{
				font-size: 12px;
				color: #fff;
				background-color: #FFBB00;
				border: 0.026667rem solid #FFBB00;
			}
		}
		.pickerbottom{
			position: fixed;
			bottom:0;
		}
		.van-button--large{
			margin-top: 40px;
			width: 85%;
			height: 50px;
			line-height: 2;
		}
		.approve-box{
			margin-top: 40%;
			
			.approve{
				width: 36px;
				height: 50px;
				margin-bottom: 30px;
			}

		}
		.gift_box{
			display: flex;
			margin: 0 15px;
			padding: 10px 15px;
			align-items: center;
			background-color:#fff;
			border-bottom:0.5px solid rgba(0,0,0,.1);
			.gift_title{
				flex: 1;
			}
			.getBtn{
				float: right;
				color: #fff;
				font-size:12px;
				padding:5px 15px;
				border-color: #FFBB00;
				background-color:#FFBB00;
			}
		}
		.iknowBtn{
			color: #fff;
			font-size:12px;
			text-align: center;
			padding:12px 25px;
			margin: 25px 30%;
			border-color: #FFBB00;
			background-color:#FFBB00;
		}
	}
</style>
